import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import {
  getDistanceBetweenPlaces,
  startPostProveedor,
} from "../../../../../../context/actions/detalleActions";
import {
  hdiTipoFechas,
  putNotification,
} from "../../../../../../context/actions/hdiActions";

export const useForma = () => {
  const dispatch = useDispatch();
  const { asistenciaID } = useParams();
  const [datos, setDatos] = useState({});

  const distanceInKmBetweenPlacesByApiGoogle = useSelector(
    (state) => state.detalleReducer.distanceInKmBetweenPlacesByApiGoogle
  );

  const {
    esGnpApi,
    latDestino,
    latOrigen,
    lngDestino,
    lngOrigen,
    folioGnp,
    estatusFinalID,
    asegurado,
    kmCalculados
  } = useSelector((state) => state.detalleReducer.asistencia);

  const proveedorPagoDirecto = useSelector((state) => state.detalleReducer.proveedorPagoDirecto);
  const { proveedorSucursalID } = useSelector((state) => state.detalleReducer.proveedorCostos);

  const { campaniaID } = asegurado;
  useEffect(() => {
    dispatch(
      getDistanceBetweenPlaces(
        { lat: parseFloat(latOrigen), lng: parseFloat(lngOrigen) },
        {
          lat: parseFloat(latDestino),
          lng: parseFloat(lngDestino),
        }
      )
    );
  }, [dispatch, lngDestino, lngDestino, lngOrigen, latOrigen]);

  useEffect(() => {
    setDatos({ ...datos, KM: distanceInKmBetweenPlacesByApiGoogle });
  }, [distanceInKmBetweenPlacesByApiGoogle]);

  useEffect(() => {
    const total = (parseFloat(datos.costoUsuarioFinal) || 0) +
                  (parseFloat(datos.costo) || 0);

    setDatos((prevDatos) => ({ ...prevDatos, costoTotalServicio: total }));
  }, [datos.costoUsuarioFinal, datos.costo]);

  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = ({ target }) => {
    let value = target.value;

    const floatFields = ['costo', 'costoClienteCorporativo', 'costoUsuarioFinal'];

    const intFields = ['tiempoLlegada'];

    if (floatFields.includes(target.name)) {
      value = value === '' ? null : parseFloat(value);
    } else if (intFields.includes(target.name)) {
      value = value === '' ? null : parseInt(value);
    }

    setDatos({
      ...datos,
      [target.name]: value,
    });
  };

  const handleChangeSelect = (val) => {
    setDatos({
      ...datos,
      localCarretero: val,
    });
  };

  const handleCuentaEspecial = (val, ele) => {
    setDatos({
      ...datos,
      [ele]: val,
    });
  };

  const handleSwitch = (val, ele) => {
    setDatos({
      ...datos,
      [ele]: val,
    });
  };

  ///////////////////

  const handleClick = async (estaAsignado) => {
    // Si el servicio es hdi hace la actualiación (verifica eso en la función)

    setErr("");

    if (
      estaAsignado &&
      (!datos.localCarretero || !datos.tiempoLlegada || !datos.costo)
    ) {
      setErr("Faltan datos");
      return;
    }

    if (
      estaAsignado &&
      datos.costoClienteCorporativo &&
      !datos.quienAutoriza
    ) {
      setErr("Debe especificar quién autoriza cuando hay costo corporativo");
      return;
    }

    if (proveedorSucursalID === 494 && !proveedorPagoDirecto) {
      setErr("El campo 'Proveedor Pago Directo' es obligatorio");
      return;
    }

    const body = {
      asistenciaID,
      estaAsignado,
      esGnpApi,
      folioGnp,
      proveedorPagoDirecto,
      ...datos,
    };

    console.log(datos);
    setLoading(true);
    try {
      await dispatch(startPostProveedor(body));
      // if(estaAsignado) {
      //   await dispatch(putNotification(hdiTipoFechas.fechaAsignacion, datos));
      // }
    } finally {
      setLoading(false);
    }
  };

  return {
    datos,
    esGnpApi,
    estatusFinalID,
    err,
    loading,
    campaniaID,
    kmCalculados,
    handleChange,
    handleChangeSelect,
    handleCuentaEspecial,
    handleSwitch,
    handleClick,
  };
};